export default "__VITE_ASSET__DUpFA7oi__"